/*
 * Module for the _Seminars partial view
*/
rs.module("ui/content/events/seminars/seminars",

    [],

    function () {

        // Initialize the module
        function initialize(listApi, backendUrls) {

            // load the corresponding detail when a list item is clicked
            listApi.onItemClick(function (e, context) {

                $.get(
                    backendUrls.getSeminarDetail,
                    {
                        seminarKey: context.SeminarKey,
                        seminarAttendanceKey: context.SeminarAttendanceKey,
                        seminarFundKey: context.FundKey
                    })
                    .done(function (html) {
                        listApi.detail.loadDetail(html);
                    })
                    .fail(function () {
                        // if the detail retrieve failed, show empty detail
                        listApi.detail.clearDetail();
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);